import type * as L from "leaflet";
import { Fab, Portal, Tooltip } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import type { Emission } from "src/types";
import { usePointSourceEmissionDraw, MapMode } from "src/hooks/usePointSourceEmissionDraw";

interface Props {
  map: L.Map;
  controlContainer: Element | null;
  emission: Emission;
  disabled: boolean;
  onDraw: (point: L.LatLngLiteral) => void;
}

export const PointSourceControlOnMap = (props: Props) => {
  const { t } = useTranslation();
  const { mapMode, toggleMapMode } = usePointSourceEmissionDraw(props.map, props.emission, {
    onDraw: props.onDraw,
  });

  function defineFabColor() {
    if (mapMode === MapMode.DRAW) return "primary";
    // else
    return "default";
  }

  // render the component
  return render();

  function render() {
    return (
      <Portal container={props.controlContainer}>
        <Tooltip
          title={mapMode === MapMode.OFF ? t<string>("label.addEmissionPoint") : t<string>("label.cancel")}
          placement="right"
        >
          <span>
            <Fab
              color={defineFabColor()}
              size="small"
              disabled={props.disabled}
              onDoubleClick={(event) => event.stopPropagation()}
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                toggleMapMode();
                return false;
              }}
            >
              <AddIcon fontSize="small" />
            </Fab>
          </span>
        </Tooltip>
      </Portal>
    );
  }
};
